<template>
  <div class="modal-root">
    <div class="modal-backdrop fade show"></div>

    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content border-0 shadow-lg">

          <div class="modal-header custom-header border-0 justify-content-center">
            <h5 class="modal-title fw-bold">Spiacente!</h5>
          </div>

          <div class="modal-body text-center py-4 px-4">
            <div class="status-icon-wrapper mb-3">
              <div class="status-icon">!</div>
            </div>

            <p class="mb-0 fw-bold fs-5">Qualcuno è stato più veloce di te.</p>
            <p class="text-muted small mt-2">
              Questo slot è stato appena prenotato da qualcun altro.<br />
              La disponibilità è cambiata mentre compilavi il modulo.
            </p>
          </div>

          <div class="modal-footer border-0 justify-content-center pb-4">
            <button type="button" class="btn-custom shadow-sm" @click="$emit('confirm')">
              SCEGLI UN ALTRO ORARIO
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionFullModal',
  emits: ['confirm'] // Dichiariamo l'evento
}
</script>

<style scoped>
.modal-root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
}

.modal-content {
  border-radius: 20px;
  overflow: hidden;
}

.custom-header {
  background: linear-gradient(90deg, #b3863b, #f1d58d);
  color: #000;
  padding: 1.2rem;
  text-align: center;
}

.status-icon-wrapper {
  margin-bottom: 15px;
}

.status-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(90deg, #b3863b, #f1d58d);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  font-weight: bold;
  margin: 0 auto;
}

/* Stile del bottone personalizzato */
.btn-custom {
  width: 80%;
  padding: 12px;
  border: 1px solid #ccdb8d;
  border-radius: 50px; /* Più arrotondato per un look moderno */
  font-size: 14px;
  font-weight: 700;
  color: black;
  background: linear-gradient(to right, #b3863b, #f1d58d);
  cursor: pointer;
  transition: 0.25s ease;
  text-transform: uppercase;
}

.btn-custom:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}

.btn-custom:active {
  transform: translateY(0);
}
</style>
